import { render } from "./NewFriend.vue?vue&type=template&id=a02910b2&scoped=true&ts=true"
import script from "./NewFriend.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewFriend.vue?vue&type=script&setup=true&lang=ts"

import "./NewFriend.vue?vue&type=style&index=0&id=a02910b2&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a02910b2"],['__file',"src/views/friend/NewFriend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a02910b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a02910b2', __exports__)) {
    console.log('reload')
    api.reload('a02910b2', __exports__)
  }
  
  module.hot.accept("./NewFriend.vue?vue&type=template&id=a02910b2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a02910b2', render)
  })

}


export default __exports__